
<template lang="pug">
  .subscription-edit
    subscription( v-bind="{ subscription, buttons: false }" )
    .actions
      button.btn--primary( @click.prevent="cancel" ) Cancel Order

    .subtitle Order Summary
    .info-block
      .row
        .left
          | {{ subscription.product_title }}
          span( v-if="subscription.quantity > 1") {{ ' x ' + subscription.quantity }}
        .right
          | ${{ subscription.price }} {{ subscription.presentment_currency }}
      hr
      .row( v-if="charge" )
        .left
          | Subtotal
        .right
          | ${{ charge.subtotal_price }} {{ subscription.presentment_currency }}
      .row( v-if="charge" )
        .left
          | Shipping ({{ charge.shipping_lines[0].title }})
        .right
          | ${{ charge.shipping_lines[0].price }} {{ subscription.presentment_currency }}
      .row( v-if="charge" )
        .left
          | Estimated Taxes
        .right
          | ${{ charge.total_tax }} {{ subscription.presentment_currency }}
      hr
      .row( v-if="charge" )
        .left
          | Estimated Total
        .right
          | ${{ subscription.price }} {{ subscription.presentment_currency }}
    .div( v-if="charge && charge.shipping_address" )
      .subtitle Shipping Address
      .info-block
        .row
          .left
            p {{ charge.shipping_address.first_name }} {{ charge.shipping_address.last_name }}
            p {{ charge.shipping_address.address1 }}
            p( v-if="charge.shipping_address.address2" ) {{ charge.shipping_address.address2 }}
            p {{ charge.shipping_address.city }}, {{ charge.shipping_address.province }}, {{ charge.shipping_address.zip }}
</template>

<script>
  import Subscription from './Subscription.vue';

  export default {
    name: 'SubscriptionEdit',

    components: {
      Subscription
    },

    props: {
      subscription: Object
    },

    setup() {
    },

    async mounted() {
      console.log('|)', this.$parent.charges, this.subscription);
      this.charge = this.$parent.charges.find((v) => v.total_price == this.subscription.price);
      console.log('|||', this.charge)
    },

    data() {
      return {
        charge: null
      }
    },

    validations () {
      return {
      }
    },

    methods: {
      cancel: function() {
        this.$parent.cancel(this.subscription);
      }
    }
  }
</script>

<style scoped lang="scss">
.subtitle {
  margin: 32px 0 16px 0;
  font-size: 1em;
  font-weight: 700;
  text-transform: uppercase;
}

.actions {
  display: flex;
  flex-direction: column;
  margin: 16px 0;

  button {
    margin: 10px 0;
  }
}

.info-block {
  margin-bottom: 32px 0 16px 0;
  border: 1px solid black;

  hr {
    margin: 0 auto;
    width: calc(100% - 32px);
    border: 0;
    border-bottom: 1px solid black;
  }

  .row {
    display: flex;
    padding: 15px 16px;
    justify-content: space-between;

    p:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
